export const shouldHideSeoText = (seoResponse, url, query) => {
  const { transport, make } = seoResponse;

  if (query && query.page > 1) return true;
  if (transport && transport.slug !== 'avto') return true;
  if (url.includes('novye') && make) return true;

  return false;
};

export const getSeoTextQuery = (baseUrl, path, isUk, urlParamsCount) => ({
  seoTextName: `${baseUrl}${path}`
    .split('/')
    .filter(Boolean)
    .slice(0, isUk ? urlParamsCount + 1 : urlParamsCount)
    .join('_'),
});



// WEBPACK FOOTER //
// ./src/shared/helpers/seoText.js